import React, { useState } from "react";
import FootballPlyarStats from "./FootballPlyarStats";
// import Link from "next/link";
const PlayerStatsInnerWrp = ({
  data,
  websiteBaseUrl,
  dataPath,
  dataClient,
}) => {
  const [active, setActive] = useState("scorers");
  const tabs = [
    { id: "scorers", label: "Top Scorers" },
    { id: "assists", label: "Top Assists" },
    { id: "cards", label: "Cards" },
  ];
  const handleTabClick = (tabId) => {
    setActive(tabId);
  };
  return (
    <div className="football_player_stats">
      <nav className="inner_tab">
        <ul>
          {tabs?.map((tab) => (
            <li
              key={tab.id}
              className={active === tab?.id ? "active" : ""}
              onClick={() => handleTabClick(tab?.id)}
            >
              <button>{tab?.label}</button>
            </li>
          ))}
        </ul>
      </nav>
      <FootballPlyarStats
        data={data}
        active={active}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        dataClient={dataClient}
      />
    </div>
  );
};

export default PlayerStatsInnerWrp;
